
if (window.glob_rx){
console.log("ONL_: GLOB_RX rx_dbg")

if (glob_rx.react.i){

// glob_rx.react.modules
Object.assign(glob_rx.react.i,{

})


Object.assign(glob_rx.react.modules,{
	
})



// glob_rx.react.i.reduxConnect

}

// glob_rx.react.i


}



